import axios from 'axios'

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: '', // 请求路径中已包含 /svip，避免前缀重复
  timeout: 60000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  }
})

// 请求拦截器 - 添加 Authorization token
apiClient.interceptors.request.use(
  (config) => {
    // 从 localStorage 或 sessionStorage 获取 token
    // const authToken = localStorage.getItem('Authorization') || 
    //                  sessionStorage.getItem('Authorization') || 
    //                  ''
    
    // if (authToken) {
    //   config.headers.Authorization = authToken
    // }
    console.log('config', config)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器 - 统一处理错误
apiClient.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    // 统一错误处理
    if (error.response) {
      // 服务器返回了错误状态码
      const { status, data } = error.response
      
      switch (status) {
        case 401:
          console.error('Unauthorized - Please check your Authorization token')
          break
        case 404:
          console.error('Resource not found')
          break
        case 500:
          console.error('Server error')
          break
        default:
          console.error('Request failed:', data?.message || error.message)
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('No response received:', error.request)
    } else {
      // 发送请求时出了点问题
      console.error('Error setting up request:', error.message)
    }
    
    return Promise.reject(error)
  }
)

export default apiClient

